import { jsx as _jsx } from "react/jsx-runtime";
import { __ } from "@jti/fe-common";
import { PasswordAction } from "@jti/rest-api";
import NewPassword from "../index";
const NewPasswordOnline = () => {
    return (_jsx(NewPassword, { title: __("auth.reset.page_title.title"), subtitle: __("auth.reset.page_title.sub_title"), ctaButtonText: __("com.login.change_password_link"), successMessage: __("reset_password.success.message"), passwordAction: PasswordAction.resetPassword }));
};
export default NewPasswordOnline;
